import React, { useState,useEffect } from "react";
import { HTTP } from "../api/http-common";
import { Eye, EyeOff, Check } from "lucide-react";
import { useGlobalContext } from "./GlobalContext";
import Swal from 'sweetalert2'

function ChangePassword() {
    const [currentPassword, setCurrentPassword] = useState("");
    const [currentPasswordError, setCurrentPasswordError] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const resetValidationErrors = () => {
        setCurrentPasswordError('');
        setNewPasswordError('');
        setConfirmPasswordError('');
    };
    const resetForm = () => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    };
    const validateField = () => {
        let checked = true;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#&?])[A-Za-z\d!@#&?]{8,64}$/;
        resetValidationErrors();
    
        
        if (currentPassword === '') {
            setCurrentPasswordError('Please enter current password');
            checked = false;
        }


        let errorMessage = '';
        if (newPassword === '') {
            setNewPasswordError('Please enter new password');
            checked = false;
        } 
        else if (!passwordRegex.test(newPassword)) {
            errorMessage = `Password must:
            - Be 8-64 characters long
            - Include both uppercase and lowercase letters
            - Contain both letters and numbers
            - Include at least one special character (e.g., ! @ # & ?)`;
            setNewPasswordError(errorMessage);
            if (checked) {
                checked = false;
            }
        }
        if (newPassword === currentPassword) {
            setNewPasswordError('New password can not be same as current password');
            if (checked) {
                checked = false;
            }
        }

        if (confirmPassword === '') {
            setConfirmPasswordError('Please enter confirm password');
            checked = false;
        } 
        if (newPassword !== confirmPassword) {
            setConfirmPasswordError('Please confirm password');
            if (checked) {
                checked = false;
            }
        }
    
        return checked;
      };
    const handleSubmit = async () => {
        if (validateField()) {
            try {
              // setIsLoading(true);
              const access_token = localStorage.getItem('access_token');
              let config = {
                headers: { "Content-Type": "application/json", token: access_token },
              };
      
              let fields = {
                password: currentPassword,
                newpassword: newPassword,
              };
              
      
              await HTTP.post(
                "/user/change/password",
                fields,
                config
              )
                .then(async (response) => {
                  if (response.status === 200) {
                      Swal.fire({
                          title: "Password changed successfully!",
                        //   text: "Please verify your email before login",
                          icon: "success"
                      });
                      resetForm();
                  }
                })
                .catch((error) => {
                  if (error.response.status === 406) {
                      resetValidationErrors();
                    //   setPasswordError(error.response.data.detail);
                    Swal.fire({
                        title: error.response.data.detail,
                      //   text: "Please verify your email before login",
                        icon: "success"
                    });
                  }
                });
      
              // setIsLoading(false);
            } catch (error) {
              // setError(error);
              // setRerenderFlag(true);
              // setIsLoading(false);
            }
          }
      };
    
  return (
    <>
        <div className="space-y-4 mt-8">
        <div className="bg-white rounded-lg p-6 border-gray-200 border">
            <h3 className="font-medium text-lg mb-6">Change Password</h3>
            <div className="flex flex-col md:flex-row md:gap-6 lg:gap-12">
            {/* Password Fields */}
            <div className="flex-1 space-y-8">
                {/* Current Password */}
                <div className="relative space-y-1">
                <input
                    type={showCurrentPassword ? "text" : "password"}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    name="current_password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all 
                    peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
                    Current Password
                </label>
                {currentPasswordError && <span className="text-sm text-red-500">{currentPasswordError}</span>}
                <button
                    type="button"
                    className="absolute right-0 bottom-2 text-gray-400"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                    {/* Eye Icon */}
                    {showCurrentPassword ? <Eye className="lucide lucide-eye h-5 w-5" /> : <EyeOff className="lucide lucide-eye h-5 w-5" />}
                </button>
                </div>

                {/* New Password */}
                <div className="relative space-y-1">
                <input
                    type={showNewPassword ? "text" : "password"}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    name="new_password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all 
                    peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
                    New Password
                </label>
                {newPasswordError && <span className="text-sm text-red-500">{newPasswordError}</span>}
                <button
                    type="button"
                    className="absolute right-0 bottom-2 text-gray-400"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                >
                    {showNewPassword ? <Eye className="lucide lucide-eye h-5 w-5" /> : <EyeOff className="lucide lucide-eye h-5 w-5" />}
                    {/* Eye Icon */}
                </button>
                </div>

                {/* Confirm Password */}
                <div className="relative space-y-1">
                <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                    name="confirm_password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all 
                    peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
                    Confirm Password
                </label>
                {confirmPasswordError && <span className="text-sm text-red-500">{confirmPasswordError}</span>}
                <button
                    type="button"
                    className="absolute right-0 bottom-2 text-gray-400"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                    {showConfirmPassword ? <Eye className="lucide lucide-eye h-5 w-5" /> : <EyeOff className="lucide lucide-eye h-5 w-5" />}
                </button>
                </div>
            </div>

            {/* Password Requirements */}
            <div className="flex-1 mt-2.5 md:mt-2.5">
                <h4 className="text-sm font-medium mb-4">Your Password Must Contain:</h4>
                <ul className="space-y-2">
                    <li className="flex items-center gap-2 text-sm text-gray-600">
                        <Check className="lucide lucide-check h-4 w-4 text-[#6C38FF]"/>
                        At least 8 characters (and up to 64 characters)
                    </li>
                    <li className="flex items-center gap-2 text-sm text-gray-600">
                        <Check className="lucide lucide-check h-4 w-4 text-[#6C38FF]"/>
                        Must include both uppercase and lowercase letters
                    </li>
                    <li className="flex items-center gap-2 text-sm text-gray-600">
                        <Check className="lucide lucide-check h-4 w-4 text-[#6C38FF]"/>
                        Must be a combination of letters and numbers
                    </li>
                    <li className="flex items-center gap-2 text-sm text-gray-600">
                        <Check className="lucide lucide-check h-4 w-4 text-[#6C38FF]"/>
                        At least one special character (e.g., ! @ # & ?)
                    </li>
                </ul>
            </div>
            </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-start">
            <button
            type="button"
            className="rounded-md bg-[#6C38FF] px-3.5 py-2 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#4D22E8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={handleSubmit}
            >
            Save Password
            </button>
        </div>
        </div>
    </>
  )
}

export default ChangePassword